import React from 'react';
import { Award, Plus, Trash2, Save, RotateCcw } from 'lucide-react';
import { useAlert } from '../../../../context/AlertContext';
import { defaultLoyaltyLevels } from '../../../../utils/loyalty';

const LoyaltyTiers = ({ t, canEdit, loyaltyDraft, setLoyaltyDraft, tenantData, handleSaveLoyalty, isSavingLoyalty }) => {
    const { showConfirm } = useAlert();

    const handleSaveWithConfirm = async () => {
        const confirmed = await showConfirm(
            'Bu değişiklik tüm müşterilerin seviyelerini etkileyebilir.',
            { title: 'Sadakat Seviyelerini Kaydet', confirmText: 'Kaydet', type: 'warning' }
        );
        if (confirmed) {
            handleSaveLoyalty();
        } else {
            const original = tenantData?.loyaltyLevels || tenantData?.loyalty_levels || [];
            setLoyaltyDraft(JSON.parse(JSON.stringify(original)));
        }
    };

    return (
    <section className="card glass">
        <style>{`
            @media (max-width: 768px) {
                .loyalty-tier-row { flex-direction: column !important; align-items: stretch !important; }
                .loyalty-tier-row > div { flex: none !important; width: 100% !important; }
                .loyalty-tier-row button { align-self: flex-end; }
                .settings-header-actions { width: 100% !important; flex-direction: row !important; justify-content: flex-start !important; }
                .settings-header-actions button { flex: 1; align-items: center; justify-content: center; }
            }
        `}</style>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1.25rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Award size={24} style={{ color: 'var(--primary)' }} />
                <div>
                    <h2 style={{ fontSize: '1.25rem', fontWeight: 700 }}>Sadakat Seviyeleri</h2>
                    <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>Müşterilerin kazandığı puanlara göre otomatik atanan rütbeler.</p>
                </div>
            </div>
            <div className="settings-header-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                {canEdit && (
                    <>
                        <button
                            onClick={() => {
                                const newLevels = [...loyaltyDraft, {
                                    id: Date.now().toString(),
                                    label: 'Yeni Seviye',
                                    minPoints: 1000,
                                    periodDays: 0,
                                    color: '#6366f1'
                                }];
                                setLoyaltyDraft(newLevels);
                            }}
                            className="btn-secondary"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.875rem', padding: '10px 16px', borderRadius: '14px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-main)', fontWeight: 600 }}
                        >
                            <Plus size={18} /> {t('common.add')}
                        </button>
                        <button
                            onClick={async () => {
                                const confirmed = await showConfirm(
                                    'Tüm sadakat seviyeleri fabrika ayarlarına döndürülecek. Devam etmek istiyor musunuz?',
                                    { title: 'Varsayılana Dön', confirmText: 'Sıfırla', type: 'warning' }
                                );
                                if (confirmed) setLoyaltyDraft(JSON.parse(JSON.stringify(defaultLoyaltyLevels)));
                            }}
                            style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 16px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-muted)', borderRadius: '14px', fontSize: '0.875rem', fontWeight: 600 }}
                            title="Varsayılan ayarlara dön"
                        >
                            <RotateCcw size={15} /> Varsayılan
                        </button>
                        <button
                            onClick={() => setLoyaltyDraft(JSON.parse(JSON.stringify(tenantData?.loyaltyLevels || tenantData?.loyalty_levels || [])))}
                            style={{ padding: '10px 16px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-main)', borderRadius: '14px', fontSize: '0.875rem', fontWeight: 600 }}
                        >
                            Vazgeç
                        </button>
                        <button
                            onClick={handleSaveWithConfirm}
                            disabled={isSavingLoyalty}
                            className="btn-primary"
                            style={{ padding: '10px 24px', borderRadius: '14px', border: 'none', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700 }}
                        >
                            <Save size={18} />
                            {isSavingLoyalty ? t('common.saving') : t('common.save')}
                        </button>
                    </>
                )}
            </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }} className="loyalty-tiers-list">
            {loyaltyDraft.map((level, index) => (
                <div key={level.id || index} className="card loyalty-tier-row" style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', padding: '1rem', display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                    <div style={{ flex: 2 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>{t('settings.tierLabel')}</label>
                        <input
                            type="text"
                            value={level.label}
                            onChange={(e) => {
                                const newLevels = [...loyaltyDraft];
                                newLevels[index] = { ...newLevels[index], label: e.target.value };
                                setLoyaltyDraft(newLevels);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Süre (Gün)</label>
                        <input
                            type="number"
                            placeholder="0 = Ömür Boyu"
                            value={level.periodDays || ''}
                            onChange={(e) => {
                                const newLevels = [...loyaltyDraft];
                                newLevels[index].periodDays = parseInt(e.target.value) || 0;
                                setLoyaltyDraft(newLevels);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Min. Puan</label>
                        <input
                            type="number"
                            value={level.minPoints}
                            onChange={(e) => {
                                const newLevels = [...loyaltyDraft];
                                newLevels[index].minPoints = parseInt(e.target.value) || 0;
                                setLoyaltyDraft(newLevels);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Renk</label>
                        <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', padding: '8px',
                            background: 'var(--bg-sidebar)', borderRadius: '10px', border: '1px solid var(--border)', minWidth: '90px'
                        }}>
                            <input
                                type="color"
                                value={level.color?.length === 7 ? level.color : '#6366f1'}
                                onChange={(e) => {
                                    const newLevels = [...loyaltyDraft];
                                    newLevels[index] = { ...newLevels[index], color: e.target.value.toUpperCase() };
                                    setLoyaltyDraft(newLevels);
                                }}
                                style={{ width: '100%', height: '28px', border: 'none', padding: 0, background: 'transparent', cursor: 'pointer', borderRadius: '4px' }}
                            />
                            <input
                                type="text"
                                value={level.color || ''}
                                placeholder="#HEX"
                                onChange={(e) => {
                                    let val = e.target.value.toUpperCase();
                                    if (val && !val.startsWith('#')) val = '#' + val;
                                    const newLevels = [...loyaltyDraft];
                                    newLevels[index] = { ...newLevels[index], color: val };
                                    setLoyaltyDraft(newLevels);
                                }}
                                style={{ border: 'none', background: 'transparent', fontSize: '0.75rem', padding: 0, width: '100%', textAlign: 'center', fontFamily: 'monospace', fontWeight: 700, outline: 'none', color: 'var(--text-main)' }}
                            />
                        </div>
                    </div>
                    <button
                        onClick={() => {
                            const newLevels = loyaltyDraft.filter((_, i) => i !== index);
                            setLoyaltyDraft(newLevels);
                        }}
                        style={{ background: 'transparent', color: '#ef4444', padding: '10px' }}
                    >
                        <Trash2 size={20} />
                    </button>
                </div>
            ))}
        </div>
    </section>
    );
};

export default LoyaltyTiers;